import { useEnterpriseConnectorRbacEnabledVariation } from '#pplx/frontend/apps/ask/generated/assignment-hooks/useEnterpriseConnectorRbacEnabledVariation.js';
/**
 * Connector-RBAC gate: the ops-controlled `enterprise-connector-rbac-enabled`
 * Eppo flag. Defaults false and stays false while the assignment loads, so
 * the RBAC UI never flashes on for ungated orgs.
 *
 * Targeting contract: `org_uuid` attribute rules ONLY — never subject
 * allowlists, never percentage rollout. The FE evaluates under the
 * `user_nextauth_id` subject with the provider's static `org_uuid` context
 * attribute; the BE (`enterprise_rbac.py`) evaluates under
 * `stable_id=org_uuid` with the same `org_uuid` extra attribute. Only an
 * `org_uuid is one of [...]` rule matches identically on both sides —
 * subject-keyed targeting would enable one side without the other.
 */
export const useIsEnterpriseConnectorRbacEnabled = () => {
    const { variation, loading } = useEnterpriseConnectorRbacEnabledVariation({
        defaultValue: false,
    });
    return {
        enabled: !loading && variation,
        loading,
    };
};
//# sourceMappingURL=useIsEnterpriseConnectorRbacEnabled.js.map